import { Flex, Text, Box } from '@chakra-ui/react';
import { useContext } from 'react';
import { GroupContext } from './CompositionGroupView';
import { useTranslation } from 'react-i18next';
import { CompositionGroupTitle } from '@texas/components/shared/compositionGroup/CompositionGroupTitle';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { PaIcon } from '@texas/components/shared/productApproval/PaIcon';

export function CompositionGroupHeader({
  customTitle,
}: {
  customTitle?: string;
}) {
  const { group, componentSettings, loading } = useContext(GroupContext)!;
  const { t } = useTranslation();

  return (
    <Flex
      flexGrow={1}
      justifyContent="space-between"
      alignItems="center"
      p={2}
      borderRadius="md"
      opacity={group?.exists ? 1 : 0.6}
    >
      <Flex flexDir="column">
        <Text fontSize="sm" fontWeight="bold">
          {customTitle}
        </Text>
        {loading ? (
          <Text variant="sub">{t('general.loadingData')}</Text>
        ) : (
          <>
            {group?.exists ? (
              <CompositionGroupTitle
                version={group.version}
                option={group.supplierId ? group.basedOnGroupVersion : null}
                note={group.supplierId ? group.basedOnGroupName : group.note}
                type={group.supplierId ? 'version' : 'option'}
                fontSize="md"
                linkedVariantId={group.linkedVariantId}
              />
            ) : (
              <Text variant="sub">{t('general.noData')}</Text>
            )}
          </>
        )}
      </Flex>
      {componentSettings?.paStates !== 'hidden' && (
        <Box>
          <AngularNavLink
            color="texas.sand.100"
            to="article.productApproval"
            navobj={{
              articleId: group?.articleId,
              branchId: group?.branchId,
              state: group?.mainProductApproval?.state,
              supplierId: group?.supplierId,
            }}
          >
            <Flex
              _light={{ color: 'texas.burntSienna.500' }}
              alignItems="center"
              gap={1}
            >
              <PaIcon state={group?.mainProductApproval?.state} />
            </Flex>
          </AngularNavLink>
        </Box>
      )}
    </Flex>
  );
}
